module.exports = __webpack_public_path__ + "img/nexo.2fda4e5b.svg";